import Utils from "platform/util/Utils";
import {MarginEventType} from "enum/MarginEventType";

enum BannerType {

    FinalizeRegistration,
    ApplyForProfessional,
    VerifyIdentity,
    Deposit,
    AccountVerification,
    InAppropriate,
    WithdrawalCancel,
    UploadDocuments,
    PendingWithdrawal,
    MarginCall,
    Liquidation
}

namespace BannerType {

    export function fromMarginEvent(type: MarginEventType): BannerType {
        if (Utils.isNotNull(type)) {
            switch (type) {
                case MarginEventType.MarginCall:
                    return BannerType.MarginCall;
                case MarginEventType.Liquidation:
                    return BannerType.Liquidation;
            }
        }
        return null;
    }
}

export {
    BannerType
};
